<script setup lang="ts">
import type { TimeEntry } from '~/types/timeEntry.type'
import { format } from 'date-fns'

defineProps({
  timeEntry: {
    type: Object as PropType<TimeEntry<undefined>>,
    required: true,
  },
})

defineEmits<{
  close: [boolean]
}>()
</script>

<template>
  <DeleteModal @close="$emit('close', $event)">
    <slot />
    <template #body>
      <div>
        Bist du dir sicher, dass du den Zeiteintrag am <span class="font-semibold">{{ `${format(timeEntry.startAt, 'dd.MM.yy')} von ${format(timeEntry.startAt, 'HH:mm')} bis ${format(timeEntry.endAt!, 'HH:mm')}` }}</span> löschen möchtest?
      </div>
    </template>
  </DeleteModal>
</template>
